import { Injectable } from '@angular/core';
import { SessionStorageService, StateService } from '../../../../../../core';
import { ModalidadeComercialFaturamento } from '../../../kpis/adapters';
import { RepresentanteModalidadeComercialFaturamentoWidgetState } from './representante-modalidade-comercial-faturamento-widget.state';

@Injectable()
/** Service para gerenciamento do state do widget de faturamento por modalidades comerciais */
export class RepresentanteModalidadeComercialFaturamentoWidgetStateService extends StateService<RepresentanteModalidadeComercialFaturamentoWidgetState> {
    constructor(sessionStorageService: SessionStorageService,) {
        super(
            sessionStorageService,
            {
                data: null
            }
        );
    }

    /** Seta os dados */
    setData(data: ModalidadeComercialFaturamento): void {
        this.state.data = data;
        this.propagateState();
    }
}
